export default{
	orders: state => state.orders,
	loading: state => state.loading,
	order: state => state.order,
}